import template from "./spray_success.html";
import en from "./en.json";
import es from "./es.json";

export default {
    name: "spraySuccess",
    template: template,
    bindings: {
        applicationRecord: "<",
    },
    translations: { en, es },
};
